import {Button, Col, Container, Row} from "react-bootstrap";
import React from "react";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../../../hooks/useTypedSelector";
import {useParams} from "react-router-dom";
import {GoArrowSwitch} from "react-icons/go";
import {resetCurrentUserStorage} from "../../../login/infrastructure/slices/currentUserSlice/currentUserSlice";
import {CornyBakersEnv} from "../../../../shared/environment/features/CornyBakersEnvironment";

export function LoggedInAs() {
    const {t} = useTranslation('common');

    const {lang} = useParams();

    const {currentUser} = useAppSelector(state => state.currentUser);


    const isMasq = currentUser?.data.is_masquerading ?? false;

    const formatLang = lang === 'nl' ? '' : `/${lang}`;

    const goBackToOwnAccount = () => {
        return new Promise<void>(() => {
            resetCurrentUserStorage();

            location.href = `${CornyBakersEnv.API_BASE_URL}/${formatLang}/switch-back`;
        });
    }

    return isMasq ? <div className={'logged-in-as'}>
        <Container>
            <Row className={'py-2'}>
                <Col className={'d-flex align-items-center'}>
                    <div>
                        {t('Logged in as')} <b>{currentUser?.name}</b>
                    </div>
                </Col>
                <Col md={"auto"}>
                    <Button onClick={goBackToOwnAccount} variant={'light'} >
                        <GoArrowSwitch className="accountMenuIcons"/>
                        {t('Back to own account')}
                    </Button>
                </Col>
            </Row>
        </Container>
    </div> : <></>
}
